function cov_1gb2fiopzx() {
  var path = "/codebuild/output/src315236701/src/src/App.vue";
  var hash = "2901d0077ebfe02d4bb1c5f4b000103c7f690407";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src315236701/src/src/App.vue",
    statementMap: {
      "0": {
        start: {
          line: 11,
          column: 19
        },
        end: {
          line: 11,
          column: 30
        }
      },
      "1": {
        start: {
          line: 12,
          column: 8
        },
        end: {
          line: 12,
          column: 26
        }
      },
      "2": {
        start: {
          line: 13,
          column: 8
        },
        end: {
          line: 18,
          column: 11
        }
      },
      "3": {
        start: {
          line: 19,
          column: 8
        },
        end: {
          line: 22,
          column: 11
        }
      },
      "4": {
        start: {
          line: 20,
          column: 12
        },
        end: {
          line: 20,
          column: 23
        }
      },
      "5": {
        start: {
          line: 21,
          column: 12
        },
        end: {
          line: 21,
          column: 74
        }
      },
      "6": {
        start: {
          line: 21,
          column: 59
        },
        end: {
          line: 21,
          column: 70
        }
      },
      "7": {
        start: {
          line: 23,
          column: 8
        },
        end: {
          line: 26,
          column: 10
        }
      },
      "8": {
        start: {
          line: 24,
          column: 43
        },
        end: {
          line: 24,
          column: 75
        }
      },
      "9": {
        start: {
          line: 25,
          column: 12
        },
        end: {
          line: 25,
          column: 72
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 10,
            column: 4
          },
          end: {
            line: 10,
            column: 5
          }
        },
        loc: {
          start: {
            line: 10,
            column: 19
          },
          end: {
            line: 27,
            column: 5
          }
        },
        line: 10
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 19,
            column: 18
          },
          end: {
            line: 19,
            column: 19
          }
        },
        loc: {
          start: {
            line: 19,
            column: 24
          },
          end: {
            line: 22,
            column: 9
          }
        },
        line: 19
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 21,
            column: 51
          },
          end: {
            line: 21,
            column: 52
          }
        },
        loc: {
          start: {
            line: 21,
            column: 57
          },
          end: {
            line: 21,
            column: 72
          }
        },
        line: 21
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 23,
            column: 15
          },
          end: {
            line: 23,
            column: 16
          }
        },
        loc: {
          start: {
            line: 23,
            column: 33
          },
          end: {
            line: 26,
            column: 9
          }
        },
        line: 23
      }
    },
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0
    },
    b: {},
    inputSourceMap: {
      version: 3,
      file: "/codebuild/output/src315236701/src/src/App.vue.ts",
      sourceRoot: "",
      sources: ["/codebuild/output/src315236701/src/node_modules/vue-cli-plugin-quasar/lib/loader.js.transform-quasar-imports.js!/codebuild/output/src315236701/src/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!/codebuild/output/src315236701/src/node_modules/vue-cli-plugin-quasar/lib/loader.vue.auto-import-quasar.js??ruleSet[0].use[1]!/codebuild/output/src315236701/src/src/App.vue?vue&type=script&setup=true&lang=ts"],
      names: [],
      mappings: "AAAA,OAAO,EAAE,eAAe,IAAI,gBAAgB,EAAE,MAAM,KAAK,CAAA;AACzD,OAAO,EAAE,gBAAgB,IAAI,iBAAiB,EAAE,SAAS,IAAI,UAAU,EAAE,WAAW,IAAI,YAAY,EAAE,MAAM,KAAK,CAAA;AAEjH,OAAO,SAAS,MAAM,sCAAsC,CAAC;AAAA,CAAC;AAC9D,OAAO,EAAE,QAAQ,EAAE,MAAM,wBAAwB,CAAC;AAElD,2BAA2B;AAC3B,yCAAyC;AAEzC,eAAe,aAAa,CAAA,gBAAgB,CAAC;IAC3C,MAAM,EAAE,KAAK;IACb,KAAK,CAAC,OAAO;QAEf,MAAM,EAAE,GAAG,SAAS,EAAE,CAAC;QACvB,EAAE,CAAC,IAAI,CAAC,GAAG,CAAC,IAAI,CAAC,CAAC;QAElB,OAAO,CAAC;YACN,KAAK,EAAE,kBAAkB;YACzB,IAAI,EAAE;gBACJ,EAAE,IAAI,EAAE,aAAa,EAAE,OAAO,EAAE,kBAAkB,EAAE;aACrD;SACF,CAAC,CAAC;QAEH,SAAS,CAAC,GAAG,EAAE;YACb,QAAQ,EAAE,CAAC;YACX,QAAQ,CAAC,gBAAgB,CAAC,WAAW,EAAE,GAAG,EAAE,GAAG,QAAQ,EAAE,CAAC,CAAC,CAAC,CAAC,CAAC;QAChE,CAAC,CAAC,CAAC;QAEH,OAAO,CAAC,IAAS,EAAC,MAAW,EAAE,EAAE;YAC/B,MAAM,sBAAsB,GAAG,iBAAiB,CAAC,aAAa,CAAE,CAAA;YAEhE,OAAO,CAAC,UAAU,EAAE,EAAE,YAAY,CAAC,sBAAsB,CAAC,CAAC,CAAA;QAC7D,CAAC,CAAA;IACD,CAAC;CAEA,CAAC,CAAA",
      sourcesContent: ["import { defineComponent as _defineComponent } from 'vue'\nimport { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from \"vue\"\n\nimport useQuasar from 'quasar/src/composables/use-quasar.js';;\nimport { activity } from './common/utils/signOut';\n\n// set quasar to dark theme\n// https://quasar.dev/quasar-plugins/dark\n\nexport default /*#__PURE__*/_defineComponent({\n  __name: 'App',\n  setup(__props) {\n\nconst $q = useQuasar();\n$q.dark.set(true);\n\nuseHead({\n  title: 'CRAFTSMAN STUDIO',\n  meta: [\n    { name: 'description', content: 'CRAFTSMAN STUDIO' },\n  ],\n});\n\nonMounted(() => {\n  activity();\n  document.addEventListener('mousemove', () => { activity(); });\n});\n\nreturn (_ctx: any,_cache: any) => {\n  const _component_router_view = _resolveComponent(\"router-view\")!\n\n  return (_openBlock(), _createBlock(_component_router_view))\n}\n}\n\n})"]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "2901d0077ebfe02d4bb1c5f4b000103c7f690407"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1gb2fiopzx = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1gb2fiopzx();
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import useQuasar from 'quasar/src/composables/use-quasar.js';
;
import { activity } from './common/utils/signOut';

import { useHead } from '@vueuse/head';
import { onMounted } from 'vue';
// set quasar to dark theme
// https://quasar.dev/quasar-plugins/dark
export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {
    cov_1gb2fiopzx().f[0]++;
    const $q = (cov_1gb2fiopzx().s[0]++, useQuasar());
    cov_1gb2fiopzx().s[1]++;
    $q.dark.set(true);
    cov_1gb2fiopzx().s[2]++;
    useHead({
      title: 'CRAFTSMAN STUDIO',
      meta: [{
        name: 'description',
        content: 'CRAFTSMAN STUDIO'
      }]
    });
    cov_1gb2fiopzx().s[3]++;
    onMounted(() => {
      cov_1gb2fiopzx().f[1]++;
      cov_1gb2fiopzx().s[4]++;
      activity();
      cov_1gb2fiopzx().s[5]++;
      document.addEventListener('mousemove', () => {
        cov_1gb2fiopzx().f[2]++;
        cov_1gb2fiopzx().s[6]++;
        activity();
      });
    });
    cov_1gb2fiopzx().s[7]++;
    return (_ctx, _cache) => {
      cov_1gb2fiopzx().f[3]++;
      const _component_router_view = (cov_1gb2fiopzx().s[8]++, _resolveComponent("router-view"));
      cov_1gb2fiopzx().s[9]++;
      return _openBlock(), _createBlock(_component_router_view);
    };
  }
});